var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    stroke: "#BCBEBF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9296 10.8125H25.3694C25.1506 10.8125 24.943 10.9129 24.8091 11.0848L15.606 22.7433L11.193 17.1518C11.1263 17.067 11.0412 16.9985 10.9441 16.9513C10.8471 16.9042 10.7406 16.8796 10.6328 16.8795H9.07249C8.92293 16.8795 8.84034 17.0513 8.93186 17.1674L15.0457 24.9129C15.3314 25.2746 15.8805 25.2746 16.1685 24.9129L27.0703 11.0982C27.1618 10.9844 27.0792 10.8125 26.9296 10.8125Z",
    fill: "#BCBEBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCompleted);
export default __webpack_public_path__ + "static/media/round-completed.ac9c70a2.svg";
export { ForwardRef as ReactComponent };